export async function getPresets() {
    const response = await fetch('https://sansiba.com/hosted/ts-player/api/presets.php');
    const fetchedPresets = await response.json();

    presets = fetchedPresets.filter((preset) => preset['For Website'].toLowerCase() === 'yes').map((preset) => {
        return {
            name: preset['Story Name'].split('(')[0].trim(),
            tempo: Number(preset.Tempo) * (preset['Meter'] === '6-8' ? 4/3 : 1),
            selection: preset.Selection,
            layers: [preset['File Name']],
            volume: Number(preset['Volume'] || 1),
            numBars: Number(preset['Bars']),
            numBarsTail: Number(preset['Tail Length (in bars)']),
            supportsChangeInMiddle: preset['Supports switching in the middle'].trim() === 'Ja',
            allowChangeInMiddle: preset['Switching in the middle allowed'].trim() === 'Ja',
            sections: [preset['Chord 1'], preset['Chord 2'], preset['Chord 3'], preset['Chord 4'], preset['Chord 5'], preset['Chord 6'], preset['Chord 7'], preset['Chord 8']].map(chord => chord.trim()).filter(chord => chord),
            elementID: preset['Tree Element ID']
        };
    });

    console.debug(JSON.stringify(presets));
    return presets;
}

export let presets = [{
    "name": "A Thousand Men",
    "tempo": 75,
    "selection": "Trailer",
    "layers": ["a-thousand-men.mp3"],
    "volume": 1,
    "numBars": 2,
    "numBarsTail": 1,
    "supportsChangeInMiddle": true,
    "allowChangeInMiddle": false,
    "sections": ["Am", "Em/G", "F", "Dm", "Am/C", "Esus2/B", "E", "Bdim/A"],
    "elementID": "demo06-01"
}, {
    "name": "Nerve",
    "tempo": 115,
    "selection": "Scifi",
    "layers": ["nerve.mp3"],
    "volume": 0.5,
    "numBars": 2,
    "numBarsTail": 1,
    "supportsChangeInMiddle": true,
    "allowChangeInMiddle": false,
    "sections": ["Dm", "Dsus4", "Edim/D", "Bb/D", "Fm", "Faug", "Dbmaj7", "Em"],
    "elementID": "demo03-02"
}, {
    "name": "Masterplan",
    "tempo": 100,
    "selection": "Action",
    "layers": ["masterplan.mp3"],
    "volume": 1,
    "numBars": 2,
    "numBarsTail": 2,
    "supportsChangeInMiddle": true,
    "allowChangeInMiddle": true,
    "sections": ["Cm", "Ab/C", "Gm/D", "Cm/Eb", "C/E", "Fm", "D7/F#", "G"],
    "elementID": "demo04-01"
}, {
    "name": "Liquid Horizons",
    "tempo": 112,
    "selection": "Mystery",
    "layers": ["liquid-horizons.mp3"],
    "volume": 1,
    "numBars": 2,
    "numBarsTail": 1,
    "supportsChangeInMiddle": true,
    "allowChangeInMiddle": false,
    "sections": ["Cm", "Bb", "F", "Dm", "Eb", "Gm/D", "F/C", "Gsus2"],
    "elementID": "demo11-01"
}, {
    "name": "Transforming Forces",
    "tempo": 110,
    "selection": "Trailer",
    "layers": ["transforming-forces.mp3"],
    "volume": 1,
    "numBars": 2,
    "numBarsTail": 1,
    "supportsChangeInMiddle": true,
    "allowChangeInMiddle": true,
    "sections": ["Cm", "Bb", "F", "Eb", "Ab", "Gm", "Fm/C", "G"],
    "elementID": "demo08-01"
}, {
    "name": "Melancholy",
    "tempo": 90,
    "selection": "Drama",
    "layers": ["melancholy.mp3"],
    "volume": 1,
    "numBars": 2,
    "numBarsTail": 2,
    "supportsChangeInMiddle": true,
    "allowChangeInMiddle": false,
    "sections": ["Cm", "Gm/Bb", "Ab", "Fm/Ab", "Bb", "Eb/Bb", "Ab/C", "Gm/D"],
    "elementID": "demo02-01"
}, {
    "name": "Forever",
    "tempo": 100,
    "selection": "Romance",
    "layers": ["forever.mp3"],
    "volume": 1,
    "numBars": 2,
    "numBarsTail": 2,
    "supportsChangeInMiddle": true,
    "allowChangeInMiddle": true,
    "sections": ["C", "Csus4", "Csus2", "Am", "F", "Gsus4", "G", "C5"],
    "elementID": "demo12-01"
}, {
    "name": "Majestic Embrace",
    "tempo": 90,
    "selection": "Action",
    "layers": ["majestic-embrace.mp3"],
    "volume": 1,
    "numBars": 2,
    "numBarsTail": 1,
    "supportsChangeInMiddle": true,
    "allowChangeInMiddle": false,
    "sections": ["Cm", "Eb", "Gm", "F", "Ab", "Gsus4", "G", "Bb"],
    "elementID": "demo04-02"
}, {
    "name": "Criminal Intentions",
    "tempo": 125,
    "selection": "Thriller",
    "layers": ["criminal-intentions.mp3"],
    "volume": 1,
    "numBars": 2,
    "numBarsTail": 1,
    "supportsChangeInMiddle": true,
    "allowChangeInMiddle": true,
    "sections": ["Cm", "Ab/C", "Bb/C", "F/C", "Fm/C", "Gm/C", "Db/C", "G/C"],
    "elementID": "demo13-02"
}, {
    "name": "Last Resort 6-8",
    "tempo": 106.66666666666666,
    "selection": "Trailer",
    "layers": ["last-resort.mp3"],
    "volume": 1,
    "numBars": 2,
    "numBarsTail": 1,
    "supportsChangeInMiddle": true,
    "allowChangeInMiddle": true,
    "sections": ["Cm", "Ab/C", "Bb/D", "Gm/D", "Ab/Eb", "Eb", "Fm", "G"],
    "elementID": "demo06-02"
}, {
    "name": "Tender Keys",
    "tempo": 100,
    "selection": "Mystery",
    "layers": ["tender-keys.mp3"],
    "volume": 1,
    "numBars": 2,
    "numBarsTail": 1,
    "supportsChangeInMiddle": true,
    "allowChangeInMiddle": false,
    "sections": ["Cmaj7", "Bm7", "Am7", "Gmaj7", "Am9", "Am/C", "Dm7", "Dm6"],
    "elementID": "demo11-011"
}, {
    "name": "Magic Woods",
    "tempo": 98,
    "selection": "Adventure",
    "layers": ["magic-woods.mp3"],
    "volume": 1,
    "numBars": 2,
    "numBarsTail": 1,
    "supportsChangeInMiddle": true,
    "allowChangeInMiddle": false,
    "sections": ["C", "Em", "F", "Dm", "Am", "Em/G", "F/C", "Gsus2"],
    "elementID": "demo10-02"
}, {
    "name": "Ruins Of Retribution 6-8",
    "tempo": 133.33333333333331,
    "selection": "Trailer",
    "layers": ["ruins-of-retribution.mp3"],
    "volume": 1,
    "numBars": 2,
    "numBarsTail": 1,
    "supportsChangeInMiddle": true,
    "allowChangeInMiddle": false,
    "sections": ["Db", "Eb", "Fm", "Cm", "Ab", "Bbm"],
    "elementID": "demo08-02"
}, {
    "name": "Ethereal Enigma",
    "tempo": 100,
    "selection": "Mystery",
    "layers": ["ethereal-enigma.mp3"],
    "volume": 1,
    "numBars": 2,
    "numBarsTail": 1,
    "supportsChangeInMiddle": true,
    "allowChangeInMiddle": false,
    "sections": ["Dm", "G", "Gm", "A", "D", "Dmaj7", "Bm", "A2"],
    "elementID": "demo11-02"
}, {
    "name": "Bad Cyborg",
    "tempo": 108,
    "selection": "Scifi",
    "layers": ["bad-cyborg.mp3"],
    "volume": 1,
    "numBars": 2,
    "numBarsTail": 1,
    "supportsChangeInMiddle": true,
    "allowChangeInMiddle": false,
    "sections": ["E5", "Edim", "Esus2", "Esus4", "Em", "Em7", "Am/E", "B/E"],
    "elementID": "demo03-02"
}, {
    "name": "Rajahs Journey",
    "tempo": 114,
    "selection": "World",
    "layers": ["rajahs-journey.mp3"],
    "volume": 1,
    "numBars": 2,
    "numBarsTail": 1,
    "supportsChangeInMiddle": true,
    "allowChangeInMiddle": false,
    "sections": ["Cm", "Bb", "F", "Eb", "Ab", "Gm", "Fm/C", "G"],
    "elementID": "demo01-02"
}];